import React from 'react';
import PropTypes from 'prop-types';
import CircleInfo from './CircleInfo';

function CircleResult({ circle, children, placementControl, categoryControl }) {
  return (
    <div className='circle-row'>
      <CircleInfo circle={circle} />
      {categoryControl && <div className='circle-category-control'>{categoryControl}</div>}
      {placementControl && <div className='circle-placement-control'>{placementControl}</div>}
      <div className='circle-actions'>{children}</div>
    </div>
  );
}

CircleResult.propTypes = {
  circle: PropTypes.object.isRequired,
  children: PropTypes.node,
  placementControl: PropTypes.node,
  categoryControl: PropTypes.node
};

export default CircleResult;
